import { render, staticRenderFns } from "./CreateOrganizerForm.vue?vue&type=template&id=1483180f&scoped=true&lang=html&"
import script from "./CreateOrganizerForm.vue?vue&type=script&lang=js&"
export * from "./CreateOrganizerForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganizerForm.vue?vue&type=style&index=0&id=1483180f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1483180f",
  null
  
)

export default component.exports